import React from 'react'

export default function LoadingComponent() {
  return (
    <div>
      <span
        style={{marginLeft: '0px'}}
        className="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </div>
  )
}
